
const initCollapsibleFilters = () => {
  
  var collapsibleContainers = document.querySelectorAll('.js-collapsible-filters');
  
  
  collapsibleContainers.forEach(function(container) {
    var toggleButton = container.querySelector('.js-toggle-link');
    var content = container.querySelector('.js-collapsible-content');

    if (toggleButton && content) {
      toggleButton.addEventListener('click', function(e) {
        e.preventDefault();
        
        
        if (content.style.display === 'none' || content.style.display === '') {
          // Mostrar conteúdo
          content.style.display = 'block';
          toggleButton.querySelector('.js-toggle-text-show-more').style.display = 'none';
          toggleButton.querySelector('.js-toggle-text-show-less').style.display = 'block';
        } else {
          // Ocultar conteúdo
          content.style.display = 'none';
          toggleButton.querySelector('.js-toggle-text-show-more').style.display = 'block';
          toggleButton.querySelector('.js-toggle-text-show-less').style.display = 'none';
        }
      });
    }
  });
}

export default initCollapsibleFilters
